export const replaceWithLineBreaks = (text) => {
  let newText = text?.replace("//", "<wbr />")
  newText = newText?.replace(/\\n/g, "<br />") // aparentemente a api tem colocado um \ a mais no \n ficando \\n -> quando resolvido remover essa linha
  return newText?.replace(/\n/g, "<br />")
}